import { Action, Mutation, Module, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import {AxiosRequestConfig} from 'axios'

interface RepresentInfo {
  //password: string;
  id: string;
  partner?: any;
}

@Module
export default class RepresentModule extends VuexModule implements RepresentInfo {
  id = ''
  partner = null
  /**
   * Get breadcrumb object for current page
   * @returns object
   */
  get getRepresentId(): string {
    return this.id;
  }

  get representPartner(): any {
    return this.partner;
  }

  @Action
  [Actions.GET_PARTNER_BY_ID](partnerCode) {
    
    this.context.commit(Mutations.SET_REPRESENT_ID, partnerCode);
    
    ApiService.setPresentAsHeader(partnerCode)
    return new Promise<void>((resolve, reject) => {
      ApiService.get("partners", partnerCode)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_REPRESENT_PARTNER, data);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject();
        });
    });
  }

  @Mutation
  [Mutations.SET_REPRESENT_ID](payload) {
    this.id = payload;
  }
  
  @Mutation
  [Mutations.SET_REPRESENT_PARTNER](payload) {
    this.partner = payload
    // Object.assign(this.partner, payload);
  }

  @Mutation
  [Mutations.CLEAR_REPRESENT]() {
    this.id = '' 
    this.partner = null
  }
}
